// extracted by mini-css-extract-plugin
module.exports = {"module":"village-queue_module__1MXRT","shrink":"village-queue_shrink__24NQ5","title":"village-queue_title__1pL0F","quarters":"village-queue_quarters__1E1lG"};